import React from 'react';

const ActivitiesNav = () => {

  const scrollToElement = (id) => {
    document.getElementById(id).scrollIntoView({
      behavior : 'smooth',
      block: 'start'
    })
  }

  return (
    <section id="activities-nav">
      
      <h1>Tartalom</h1>

      <ul>
        <li>
          <a href={"#activities-waste"} onClick={ (event)=> {scrollToElement("activities-waste"); event.preventDefault()}}>Hulladékkezelés, szállítás</a>
        </li>
        <li>
          <a href={"#activities-real-estate"} onClick={ (event)=> {scrollToElement("activities-real-estate"); event.preventDefault()}}>Ingatlankezelés, közös képviselet</a>
        </li>
        <li>
          <a href={"#activities-construction"} onClick={ (event)=> {scrollToElement("activities-construction"); event.preventDefault()}}>Építőipari tevékenység</a>
        </li>
        <li>
          <a href={"#activities-park"} onClick={ (event)=> {scrollToElement("activities-park"); event.preventDefault()}}>Parkgondozás, köztisztaság</a>
        </li>
        <li>
          <a href={"#activities-flood"} onClick={ (event)=> {scrollToElement("activities-flood"); event.preventDefault()}}>Bel- és csapadékvíz elvezetés</a>
        </li>
        <li>
          <a href={"#activities-market"} onClick={ (event)=> {scrollToElement("activities-market"); event.preventDefault()}}>Piaccsarnok és piactér üzemeltetés</a>
        </li>
        <li>
          <a href={"#activities-public-cleaning"} onClick={ (event)=> {scrollToElement("activities-public-cleaning"); event.preventDefault()}}>Köztisztasági telep</a>
        </li>
        <li>
          <a href={"#activities-snow"} onClick={ (event)=> {scrollToElement("activities-snow"); event.preventDefault()}}>Hó- és síkosságmentesítés</a>
        </li>
        <li>
          <a href={"#activities-funeral"} onClick={ (event)=> {scrollToElement("activities-funeral"); event.preventDefault()}}>Temetkezés, temetőüzemeltetés</a>
        </li>
        <li>
          <a href={"#activities-flower"} onClick={ (event)=> {scrollToElement("activities-flower"); event.preventDefault()}}>Virágbolt</a>
        </li>
      </ul>

    </section>
  );
};    

export default ActivitiesNav;